import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  page: {
    'method': 'GET',
    'url': '/api/v1/abilities'
  },
  full: {
    'method': 'GET',
    'url': '/api/v1/abilities/all_full'
  }
}

export default Vue.resource('/api/v1/abilities{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/ability.js